import React from 'react'

function CoolingCeilingTech() {
  return (
    <embed src="\pdfs\E2.1.1_K181e_Cooling_ceiling_technology_09.2001_kr.pdf" width="100%" height="2100px" />
  )
}

export default CoolingCeilingTech